const { Core, Utils, Events } = Global;
const { $loading, $fetch, parseHTML } = Utils;

customElements.define('cart-drawer', class extends Core {
    elements = {
        'modal': 'modal-container'
    }

    render() {
        this.sub(Events.CART_UPDATE, this._handleAddingToCart, { global: true });
        this.sub(Events.CART_CHANGE, this._handleCartChange, { global: true });
        this.sub(Events.CART_REPLACE, this._handleCartChange, { global: true });
        this.sub(Events.CART_DRAWER_MUTE, this._handleMute, { once: true, global: true });
        this.sub(Events.CART_ERROR, this._handleCartError, { global: true });
 
        if (!this._nativeQtyHandlersBound) {
            this._nativeQtyHandlersBound = true;

            document.addEventListener('click', async (e) => {
                const element = e.target.closest('cart-qty');
                if (!element) return;

                e.preventDefault();
                e.stopPropagation();

                const itemKey = element.getAttribute('key');
                const newValue = parseInt(element.getAttribute('value'), 10);
                if (element.classList.contains('processing') || isNaN(newValue)) {
                    return;
                }

                element.classList.add('processing');
                const productContainer = element.closest('[data-item-key]') || element.closest('.\\#cart-drawer-product');

                try {
                    if (productContainer) {
                        $loading(productContainer, true);
                    }

                    element.classList.add('loading');
                    element.setAttribute('disabled', 'disabled');

                    const updateResponse = await fetch('/cart/change.js', {
                        method: 'POST',
                        headers: {
                            'Content-Type': 'application/json',
                            'Accept': 'application/json'
                        },
                        body: JSON.stringify({
                            id: itemKey,
                            quantity: newValue
                        })
                    });

                    if (!updateResponse.ok) {
                        throw new Error('Cart update failed');
                    }

                    setTimeout(async () => {
                        try {
                            if (typeof window.debouncedPriceUpdate === 'function') {
                                await window.debouncedPriceUpdate();
                            } else if (typeof window.updateCartPrices === 'function') {
                                await window.updateCartPrices();
                            }
                        } catch (priceError) {
                            console.error('Price update failed:', priceError);
                        } finally {
                            if (productContainer) {
                                $loading(productContainer, false);
                            }
                            element.classList.remove('loading', 'processing');
                            element.removeAttribute('disabled');
                        }
                    }, 200);
                } catch (error) {
                    console.error('Cart quantity update failed:', error);
                    if (productContainer) {
                        $loading(productContainer, false);
                    }
                    element.classList.remove('loading', 'processing');
                    element.removeAttribute('disabled');
                    alert('Unable to update quantity. Please try again.');
                }
            });

            document.addEventListener('focus', (e) => {
                const input = e.target.closest('.\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input');
                if (!input) return;
                if (!input.dataset.originalValue) {
                    input.dataset.originalValue = input.value;
                }
                input.value = '';
            }, true);

            document.addEventListener('keydown', (e) => {
                const input = e.target.closest('.\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input');
                if (!input) return;
                if (e.key === 'Enter' || e.keyCode === 13) {
                    e.preventDefault();
                    e.stopPropagation();
                    input.blur();
                }
            });

            document.addEventListener('blur', (e) => {
                const input = e.target.closest('.\\#cart-drawer-quantity-controls-input, .cart-drawer-quantity-controls-input');
                if (!input) return;

                const itemKey = input.dataset.itemKey || input.getAttribute('data-item-key');
                const line = parseInt(input.dataset.line || input.getAttribute('data-line'), 10);
                if (!itemKey || isNaN(line)) return;

                const maxValue = input.hasAttribute('max') && +input.getAttribute('max');
                const minValue = input.hasAttribute('data-minValue') && +input.getAttribute('data-minValue');
                const step = input.hasAttribute('step') && +input.getAttribute('step');
                let newValue = parseInt(input.value, 10);

                if (isNaN(newValue) || input.value === '') {
                    const originalValue = parseInt(input.dataset.originalValue || input.getAttribute('value'), 10) || 0;
                    input.value = originalValue;
                    delete input.dataset.originalValue;
                    return;
                }

                if (maxValue && newValue > maxValue) {
                    input.value = maxValue;
                    newValue = maxValue;
                } else if (minValue && newValue < minValue) {
                    input.value = 0;
                    newValue = 0;
                } else if (step && newValue % step !== 0) {
                    newValue = Math.ceil(newValue / step) * step;
                    input.value = newValue;
                }

                const storedOriginalValue = input.dataset.originalValue;
                const originalValue = storedOriginalValue ? parseInt(storedOriginalValue, 10) : (parseInt(input.getAttribute('value'), 10) || 0);
                if (newValue === originalValue) {
                    delete input.dataset.originalValue;
                    return;
                }

                input.setAttribute('value', newValue);
                delete input.dataset.originalValue;

                this.pub(Events.CART_CHANGE, {
                    key: itemKey,
                    line: line,
                    quantity: newValue
                });
            }, true);
        }

        window.updateCartPrices = (function(){
            let inFlight = null;
            return async function(qtyOverrides = {}) {
            if (inFlight) return inFlight;

            inFlight = (async () => {
                try {
                    // console.log('Starting price update...');
                    
                    const cartResp = await fetch('/cart.js', { cache: 'no-store' });
                    if (!cartResp.ok) {
                        console.warn('Failed to fetch /cart.js', cartResp.status);
                        return;
                    }
                    const cart = await cartResp.json();

                    const itemsByKey = new Map();
                    cart.items.forEach(item => {
                        if (item.key) itemsByKey.set(item.key, item);
                    });

                    const productElements = document.querySelectorAll('.\\#cart-drawer-product, .cart-drawer-product');
                    if (!productElements || productElements.length === 0) {
                        // console.log('No product elements found');
                        return;
                    }

                    const skuToItemKeys = new Map();
                    const keyToDomEl = new Map();

                    productElements.forEach(el => {
                        const itemKey = el.getAttribute('data-item-key') || el.dataset.itemKey;
                        let cartItem = itemKey && itemsByKey.has(itemKey) ? itemsByKey.get(itemKey) : null;

                        let sku = '';
                        if (cartItem) {
                            sku = cartItem.sku || '';
                        } else {
                            const img = el.querySelector('img');
                            if (img && img.getAttribute('src')) {
                                const filename = img.getAttribute('src').split('/').pop() || '';
                                sku = filename.split('_')[0] || '';
                            }
                        }

                        const finalQty = cartItem ? cartItem.quantity : 0;
                        if (!sku || finalQty === 0) return;

                        if (itemKey) keyToDomEl.set(itemKey, el);

                        if (!skuToItemKeys.has(sku)) skuToItemKeys.set(sku, []);
                        skuToItemKeys.get(sku).push({ key: itemKey, qty: finalQty, cartItem });


                    });

                    // console.log('SKU mappings:', skuToItemKeys);

                    const skuPrices = new Map();
                    const ajaxPromises = [];

                    for (const [sku, entries] of skuToItemKeys.entries()) {
                        const maxQty = entries.reduce((m, e) => Math.max(m, e.qty || 0), 0);

                        const encodedValues = encodeURIComponent(JSON.stringify({
                            skuAndDomainName: {
                                productSKU: [sku],
                                domainName: "ace-products-group.myshopify.com",
                                tag: window.productTag,
                                NSID: window.productNSID
                            }
                        }));

                        const p = (async () => {
                            try {
                                const data = await window.WebbeeAPI.request({
                                    method: 'GET',
                                    url: "https://hooks.webbeeglobal.com/NetsuiteSuitetalkWeb/quantity-pricing/product",
                                    data: encodedValues,
                                    timeout: 10000
                                });
                                const responseJSON = window.WebbeeAPI.parseProductValues(data);
                                if (!responseJSON) return;

                                const skuData = responseJSON[sku] || [];
                                if (skuData && skuData.length) {
                                    let matched = null;
                                    for (let i = 0; i < skuData.length; i++) {
                                        const row = skuData[i];
                                        if (maxQty >= row.quantity_min && maxQty <= row.quantity_max) {
                                            matched = row;
                                            break;
                                        }
                                    }
                                    if (!matched && skuData.length) matched = skuData[skuData.length - 1];
                                    if (matched) {
                                        skuPrices.set(sku, { unit: parseFloat(matched.amount), raw: matched });
                                    }
                                }
                            } catch (error) {
                                console.error('Quantity pricing request failed for SKU', sku, error);
                            }
                        })();
                        ajaxPromises.push(p);
                    }

                    await Promise.all(ajaxPromises);
                    // console.log('All pricing requests completed:', skuPrices);

                    let computedSubtotal = 0;
                    for (const [sku, entries] of skuToItemKeys.entries()) {
                        const priceInfo = skuPrices.get(sku);
                        if (!priceInfo) continue;

                        const unitPrice = priceInfo.unit;

                        for (const entry of entries) {
                            const qty = entry.qty || 0;
                            const lineTotal = unitPrice * qty;
                            computedSubtotal += lineTotal;

                            const el = entry.key ? keyToDomEl.get(entry.key) : null;
                            if (el) {
                                const priceEl = el.querySelector('.\\#product-card-min-price, .product-card-min-price');
                                if (priceEl) {
                                    const newPrice = '$ ' + unitPrice.toFixed(2);
                                    if (priceEl.textContent !== newPrice) {
                                        priceEl.textContent = newPrice;
                                        priceEl.dataset.finalPrice = unitPrice.toFixed(2);
                                    }
                                }

                                const lineTotalEl = el.querySelector('.cart-line-total, .\\#cart-line-total');
                                if (lineTotalEl) {
                                    lineTotalEl.textContent = '$ ' + lineTotal.toFixed(2);
                                }
                            }
                        }
                    }

                    const priceEls = document.querySelectorAll('.\\#cart-drawer-subtotal-item-price, .cart-drawer-subtotal-item-price');
                    let discount = 0;
                    if (priceEls && priceEls.length >= 2) {
                        const discountStr = priceEls[1].textContent.trim().replace(/[^0-9.-]+/g, '');
                        discount = parseFloat(discountStr) || 0;
                    }

                    if (priceEls && priceEls.length >= 1) {
                        priceEls[0].textContent = '$ ' + computedSubtotal.toFixed(2);
                    }
                    const finalSubtotalEl = (priceEls && priceEls.length === 3) ? priceEls[2] : (priceEls && priceEls[1]);
                    if (finalSubtotalEl) {
                        finalSubtotalEl.textContent = '$ ' + (computedSubtotal + discount).toFixed(2);
                    }

                    const checkoutTotalSpan = document.querySelector('.\\#cart_checkout .\\#cart-drawer-checkout-total, .cart-checkout-total, .\\#cart_checkout .cart-checkout-total');
                    if (checkoutTotalSpan) {
                        checkoutTotalSpan.textContent = '$ ' + (computedSubtotal + discount).toFixed(2);
                    }

                    // console.log('Price update completed successfully. New subtotal:', computedSubtotal.toFixed(2));

                } catch (err) {
                    console.error('updateCartPrices error:', err);
                } finally {
                    inFlight = null;
                }
            })();

            return inFlight;
            };
            })();

        // Initialize upsell quantity constraints based on product metafields
        // Wait for BOLD to be ready and cart drawer to open
        this._waitForBoldAndInitialize();

    }  

    /**
     * Wait for BOLD API to be ready and cart drawer to open before initializing constraints
     */
    _waitForBoldAndInitialize() {
        // Prevent duplicate initialization
        if (this._upsellConstraintsInitialized) {
            return;
        }

        // Check if BOLD is already available
        const checkBoldReady = () => {
            // Check for window.BOLD API (common BOLD pattern)
            if (window.BOLD && typeof window.BOLD === 'object') {
                return true;
            }
            // Check for BOLD common initialization patterns
            if (window.BoldApps || window.BoldCommon) {
                return true;
            }
            // Check if BOLD elements are present (fallback)
            const boldElements = document.querySelector('.product-offer-carousel, .cart-drawer-upsell-offer');
            return !!boldElements;
        };

        // Wait for BOLD to be ready
        const waitForBold = () => {
            return new Promise((resolve) => {
                if (checkBoldReady()) {
                    resolve();
                    return;
                }

                // Poll for BOLD availability
                const checkInterval = setInterval(() => {
                    if (checkBoldReady()) {
                        clearInterval(checkInterval);
                        resolve();
                    }
                }, 100);

                // Timeout after 5 seconds (BOLD should load by then)
                setTimeout(() => {
                    clearInterval(checkInterval);
                    resolve(); // Resolve anyway to proceed
                }, 5000);
            });
        };

        // Check if modal dialog is open
        const isModalOpen = () => {
            const modal = this.$('modal');
            if (!modal) return false;
            const dialog = typeof modal.$ === 'function'
                ? modal.$('dialog')
                : modal.querySelector('dialog');
            return dialog && dialog.open;
        };

        // Initialize constraints when ready
        const initializeConstraints = () => {
            waitForBold().then(() => {
                // Give BOLD a moment to inject content after drawer opens
                setTimeout(() => {
                    if (!this._upsellConstraintsInitialized) {
                        // console.log('BOLD ready, initializing upsell constraints');
                        this._upsellConstraintsInitialized = true;
                        this._initializeUpsellQuantityConstraints();
                    } else {
                        // If already initialized, just process any new offers that may have been added
                        // console.log('Re-processing upsell offers (drawer reopened)');
                        this._processUpsellOffers();
                    }
                }, 500);
            });
        };

        // Set up listener for cart drawer open events
        const modal = this.$('modal');
        if (!modal) {
            console.warn('Modal container not found, cannot initialize upsell constraints');
            return;
        }

        // Handle modal open event
        const handleModalOpen = () => {
            initializeConstraints();
        };

        // Listen for modal-open events (fires when modal opens)
        modal.addEventListener('modal-open', handleModalOpen);
        
        // Also listen for the bubbling event on document (backup)
        document.addEventListener('modal-open', (e) => {
            // Only handle if it's our cart drawer modal
            if (e.target === modal || modal.contains(e.target)) {
                initializeConstraints();
            }
        });

        // If drawer is already open (e.g., on page load), initialize immediately
        if (isModalOpen()) {
            initializeConstraints();
        }
    }

    /**
     * Initialize quantity constraints for BOLD upsell offers based on product metafields
     * Watches for upsell components and applies minimum_quantity and quantity_multiplier rules
     */
    _initializeUpsellQuantityConstraints() {
        // console.log('Initializing upsell quantity constraints');
        // Process existing upsell offers
        this._processUpsellOffers();
        
        // console.log('Processed existing upsell offers');

        // Watch for new upsell offers being added dynamically
        const observer = new MutationObserver((mutations) => {
            mutations.forEach((mutation) => {
                // Handle removed nodes - clean up intervals and event handlers
                mutation.removedNodes.forEach((node) => {
                    if (node.nodeType === 1) {
                        // Check if an upsell offer was removed (unmounted)
                        const wasUpsellOffer = node.classList && node.classList.contains('cart-drawer-upsell-offer');
                        const containedUpsellOffer = node.querySelector && node.querySelector('.cart-drawer-upsell-offer');
                        
                        if (wasUpsellOffer || containedUpsellOffer) {
                            // Upsell component unmounted - trigger cart refresh
                            // console.log('Upsell component unmounted, triggering cart refresh');
                            this._triggerCartRefresh();
                        }
                        
                        if (node._valueCheckInterval) {
                            clearInterval(node._valueCheckInterval);
                        }
                        if (node._addToCartTimeout) {
                            clearTimeout(node._addToCartTimeout);
                        }
                        // Clean up event handlers
                        if (node._cartUpdateHandler) {
                            this.unsub(Events.CART_UPDATE, node._cartUpdateHandler);
                        }
                        if (node._cartErrorHandler) {
                            this.unsub(Events.CART_ERROR, node._cartErrorHandler);
                        }
                    }
                });
                
                // Handle added nodes - process new offers
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType === 1) { // Element node
                        // Check if the added node is an upsell offer or contains one
                        if (node.classList && node.classList.contains('cart-drawer-upsell-offer')) {
                            this._processUpsellOffer(node);
                        } else if (node.querySelector) {
                            const offers = node.querySelectorAll('.cart-drawer-upsell-offer');
                            offers.forEach(offer => {
                                // Clean up any existing intervals on offers being replaced
                                if (offer._valueCheckInterval) {
                                    clearInterval(offer._valueCheckInterval);
                                }
                                if (offer._addToCartTimeout) {
                                    clearTimeout(offer._addToCartTimeout);
                                }
                                this._processUpsellOffer(offer);
                            });
                        }
                    }
                });
            });
        });

        // Observe the cart drawer for changes
        const cartDrawer = this.querySelector('.product-offer-carousel') || this;
        if (cartDrawer) {
            observer.observe(cartDrawer, {
                childList: true,
                subtree: true
            });
        }
    }

    /**
     * Process all existing upsell offers in the cart drawer
     */
    _processUpsellOffers() {
        const offers = this.querySelectorAll('.cart-drawer-upsell-offer');
        const previousOfferCount = this._lastOfferCount || 0;
        const currentOfferCount = offers.length;
        
        // If offers decreased, trigger cart refresh
        if (previousOfferCount > 0 && currentOfferCount < previousOfferCount) {
            // console.log(`Upsell offers decreased from ${previousOfferCount} to ${currentOfferCount}, triggering cart refresh`);
            setTimeout(() => {
                this._triggerCartRefresh();
            }, 300);
        }
        
        this._lastOfferCount = currentOfferCount;
        
        offers.forEach(offer => {
            if (!offer.dataset.processed) {
                this._processUpsellOffer(offer);
            }
        });
    }

    /**
     * Process a single upsell offer to apply quantity constraints
     */
    async _processUpsellOffer(offerElement) {
        // Mark as processed to avoid duplicate processing
        offerElement.dataset.processed = 'true';

        // Get the product ID from the add to cart button
        const addToCartButton = offerElement.querySelector('.product-offer-add-to-cart-button');
        if (!addToCartButton) return;

        const productId = addToCartButton.getAttribute('data-bold-product-id');
        if (!productId) return;

        // Get the product URL from the anchor tag
        const productLink = offerElement.querySelector('a.horizontal-stack');
        if (!productLink) return;

        const productUrl = productLink.getAttribute('href');
        if (!productUrl) return;

        try {
            // Fetch product data with metafields
            // The product JSON endpoint (/products/{handle}.js) doesn't include metafields,
            // so we need to fetch the product page HTML and extract metafields from rendered elements
            const productHandle = productUrl.replace('/products/', '').split('?')[0];
            const fullProductUrl = productUrl.startsWith('/') ? productUrl : `/products/${productHandle}`;
            
            let minimumQuantity = null;
            let quantityMultiplier = null;
            let variantSku = null; // Declare outside try block for scope
            
            // Fetch the product page HTML and look for metafield values in rendered elements
            // The metafields are rendered in the product-qty-selector input as min and step attributes
            try {
                const productPageResponse = await fetch(fullProductUrl);
                
                if (!productPageResponse.ok) {
                    console.warn(`Failed to fetch product page for ${productHandle}`);
                    return;
                }
                
                const productPageHtml = await productPageResponse.text();
                const productPageDoc = parseHTML(productPageHtml);
                
                // Look for the product quantity selector input which has min and step attributes
                // that contain the metafield values (minimum_quantity and quantity_multiplier)
                const qtyInput = productPageDoc.querySelector('.\\#product-qty-selector-controls-input, .product-qty-selector-controls-input, input[data-element="input"][type="number"]');
                
                if (qtyInput) {
                    // Extract min attribute (contains minimum_quantity metafield)
                    const minAttr = qtyInput.getAttribute('min');
                    if (minAttr && minAttr !== '1') {
                        minimumQuantity = parseInt(minAttr, 10);
                    }
                    
                    // Extract step attribute (contains quantity_multiplier metafield)
                    const stepAttr = qtyInput.getAttribute('step');
                    if (stepAttr && stepAttr !== '1') {
                        quantityMultiplier = parseInt(stepAttr, 10);
                    }
                }
                
                // Fallback: Look for hidden input with minimum_quantity value
                if (!minimumQuantity) {
                    const hiddenQtyInput = productPageDoc.querySelector('input[name="quantity"][type="hidden"]');
                    if (hiddenQtyInput && hiddenQtyInput.value && hiddenQtyInput.value !== '1') {
                        const qtyValue = parseInt(hiddenQtyInput.value, 10);
                        if (!isNaN(qtyValue) && qtyValue > 1) {
                            minimumQuantity = qtyValue;
                        }
                    }
                }
                
                // Fallback: Look for script tags that might contain metafield values
                // (some themes might render metafields in script tags)
                if (!minimumQuantity || !quantityMultiplier) {
                    const scripts = productPageDoc.querySelectorAll('script');
                    for (const script of scripts) {
                        const scriptContent = script.textContent || '';
                        // Look for patterns like minimum_quantity or quantity_multiplier in script content
                        const minMatch = scriptContent.match(/minimum_quantity['":\s]*(\d+)/i);
                        const multMatch = scriptContent.match(/quantity_multiplier['":\s]*(\d+)/i);
                        
                        if (minMatch && !minimumQuantity) {
                            minimumQuantity = parseInt(minMatch[1], 10);
                        }
                        if (multMatch && !quantityMultiplier) {
                            quantityMultiplier = parseInt(multMatch[1], 10);
                        }
                    }
                }
                
                // console.log('Extracted metafields from product page:', { minimumQuantity, quantityMultiplier });
                
                // Get variant ID and SKU for price fetching (while we have productPageDoc in scope)
                const variantId = addToCartButton.getAttribute('data-bold-variant-id');
                
                if (variantId) {
                    try {
                        // Look for variant data in script tags
                        const variantScripts = productPageDoc.querySelectorAll('script[type="application/json"]');
                        for (const script of variantScripts) {
                            try {
                                const data = JSON.parse(script.textContent);
                                // Check if this contains variant data
                                if (data && typeof data === 'object') {
                                    // Look for variant with matching ID
                                    for (const key in data) {
                                        if (data[key] && data[key].id === parseInt(variantId, 10)) {
                                            variantSku = data[key].sku;
                                            break;
                                        }
                                    }
                                }
                            } catch (e) {
                                // Not valid JSON or doesn't contain variant data
                            }
                        }
                        
                        // Fallback: Look for variant selector or product form that might have SKU
                        if (!variantSku) {
                            const variantSelect = productPageDoc.querySelector(`select[name="id"]`);
                            if (variantSelect) {
                                const option = variantSelect.querySelector(`option[value="${variantId}"]`);
                                if (option) {
                                    variantSku = option.dataset.sku || option.getAttribute('data-sku');
                                }
                            }
                        }
                    } catch (skuError) {
                        console.warn('Failed to extract variant SKU from product page', skuError);
                    }
                }
                
                // Fallback: Try to get SKU from product JSON endpoint if not found in HTML
                if (!variantSku && variantId) {
                    try {
                        const productJsonResponse = await fetch(`${fullProductUrl}.js`);
                        if (productJsonResponse.ok) {
                            const productData = await productJsonResponse.json();
                            const variant = productData.variants?.find(v => v.id === parseInt(variantId, 10));
                            if (variant) {
                                variantSku = variant.sku;
                            }
                        }
                    } catch (jsonError) {
                        console.warn('Failed to fetch variant SKU from JSON', jsonError);
                    }
                }
                
            } catch (error) {
                console.warn('Failed to fetch product page for metafields', error);
                return;
            }

            // If no metafields are set, use defaults
            if (minimumQuantity === null && quantityMultiplier === null) {
                return;
            }

            // Apply constraints to the quantity input
            const quantityInput = offerElement.querySelector('.upsell-cart-drawer-bold-quantity-input');
            if (!quantityInput) return;

            const minQty = minimumQuantity !== null ? minimumQuantity : 1;
            const step = quantityMultiplier !== null ? quantityMultiplier : 1;

            // Update input attributes
            quantityInput.setAttribute('min', minQty);
            quantityInput.setAttribute('step', step);
            quantityInput.setAttribute('data-min-quantity', minQty);
            quantityInput.setAttribute('data-quantity-multiplier', step);

            // Get current value and adjust if needed
            let currentValue = parseInt(quantityInput.value, 10) || minQty;
            
            // Ensure value meets minimum
            if (currentValue < minQty) {
                currentValue = minQty;
            }
            
            // Ensure value is a multiple of step
            if (step > 1 && currentValue % step !== 0) {
                currentValue = Math.ceil(currentValue / step) * step;
            }

            quantityInput.value = currentValue;
            
            // Update the data attribute on the button as well
            addToCartButton.setAttribute('data-bold-quantity', currentValue);

            // Update button states
            const minusButton = offerElement.querySelector('button[name="minus"]');
            const plusButton = offerElement.querySelector('button[name="plus"]');

            // Disable minus button if at minimum
            if (minusButton) {
                if (currentValue <= minQty) {
                    minusButton.classList.add('disabled');
                    minusButton.disabled = true;
                } else {
                    minusButton.classList.remove('disabled');
                    minusButton.disabled = false;
                }
            }

            // Set up increment/decrement handlers with price update functionality
            // variantSku and variantId are available from the try block above
            this._setupUpsellQuantityHandlers(offerElement, minQty, step, quantityInput, minusButton, plusButton, addToCartButton, variantSku, fullProductUrl);
            
            // Set up add to cart button with processing state
            this._setupUpsellAddToCartButton(offerElement, addToCartButton);

        } catch (error) {
            console.error('Error processing upsell offer:', error);
        }
    }

    /**
     * Set up event handlers for upsell quantity controls
     * Uses a non-invasive approach that works alongside BOLD's existing handlers
     */
    _setupUpsellQuantityHandlers(offerElement, minQty, step, quantityInput, minusButton, plusButton, addToCartButton, variantSku, productUrl) {
        // Store constraints on the input for reference
        quantityInput.dataset.minQty = minQty;
        quantityInput.dataset.step = step;

        // Validation function
        const validateAndAdjust = (value) => {
            let adjustedValue = parseInt(value, 10);
            
            if (isNaN(adjustedValue) || adjustedValue < minQty) {
                adjustedValue = minQty;
            }
            
            // Ensure value is a multiple of step
            if (step > 1 && adjustedValue % step !== 0) {
                adjustedValue = Math.ceil(adjustedValue / step) * step;
            }
            
            return adjustedValue;
        };

        // Update button states based on current value
        const updateButtonStates = (value) => {
            if (minusButton) {
                if (value <= minQty) {
                    minusButton.classList.add('disabled');
                    minusButton.disabled = true;
                } else {
                    minusButton.classList.remove('disabled');
                    minusButton.disabled = false;
                }
            }
        };

        // Track last known value to detect changes
        let lastValue = parseInt(quantityInput.value, 10) || minQty;

        // Price update function
        const updatePrice = async (quantity) => {
            if (!variantSku) {
                console.warn('No SKU available for price update');
                return;
            }

            const priceElement = offerElement.querySelector('.product-offer-price');
            if (!priceElement) {
                return;
            }

            try {
                // Fetch price from WebBee API
                const encodedValues = encodeURIComponent(JSON.stringify({
                    skuAndDomainName: {
                        productSKU: [variantSku],
                        domainName: "ace-products-group.myshopify.com",
                        tag: window.productTag || '',
                        NSID: window.productNSID || ''
                    }
                }));

                const priceResponse = await window.WebbeeAPI.request({
                    method: 'GET',
                    url: "https://hooks.webbeeglobal.com/NetsuiteSuitetalkWeb/quantity-pricing/product",
                    data: encodedValues,
                    timeout: 10000
                });

                if (priceResponse && priceResponse.productValues && priceResponse.productValues !== "null") {
                    const responseJSON = JSON.parse(priceResponse.productValues);
                    const skuData = responseJSON[variantSku] || [];
                    
                    if (skuData && skuData.length) {
                        // Find matching price tier for the quantity
                        let matchedTier = null;
                        for (let i = 0; i < skuData.length; i++) {
                            const row = skuData[i];
                            if (quantity >= row.quantity_min && quantity <= row.quantity_max) {
                                matchedTier = row;
                                break;
                            }
                        }
                        
                        // If no exact match, use the highest tier (last one)
                        if (!matchedTier && skuData.length) {
                            matchedTier = skuData[skuData.length - 1];
                        }
                        
                        if (matchedTier) {
                            const unitPrice = parseFloat(matchedTier.amount);
                            // Update price display (format: $ X.XX)
                            priceElement.textContent = `$ ${unitPrice.toFixed(2)}`;
                            // console.log(`Updated price for quantity ${quantity}: $${unitPrice.toFixed(2)}`);
                        }
                    }
                }
            } catch (priceError) {
                console.warn('Failed to fetch price for upsell offer', priceError);
            }
        };

        // Watch for value changes using a combination of events and polling
        const checkValue = () => {
            const currentValue = parseInt(quantityInput.value, 10);
            if (!isNaN(currentValue) && currentValue !== lastValue) {
                lastValue = currentValue;
                const adjustedValue = validateAndAdjust(currentValue);
                if (adjustedValue !== currentValue) {
                    quantityInput.value = adjustedValue;
                    addToCartButton.setAttribute('data-bold-quantity', adjustedValue);
                    lastValue = adjustedValue;
                }
                updateButtonStates(adjustedValue);
                // Update price when quantity changes
                updatePrice(adjustedValue);
            }
        };

        // Poll for value changes (catches programmatic changes from BOLD)
        // Note: Interval will be cleaned up when the cart drawer is closed/removed
        const valueCheckInterval = setInterval(checkValue, 50);
        
        // Store interval ID on element for potential cleanup
        offerElement._valueCheckInterval = valueCheckInterval;

        // Handle button clicks - adjust values after BOLD's handlers
        if (plusButton) {
            plusButton.addEventListener('click', () => {
                setTimeout(() => {
                    const currentValue = parseInt(quantityInput.value, 10) || minQty;
                    const newValue = currentValue + step;
                    quantityInput.value = newValue;
                    addToCartButton.setAttribute('data-bold-quantity', newValue);
                    lastValue = newValue;
                    updateButtonStates(newValue);
                    updatePrice(newValue);
                }, 10);
            });
        }

        if (minusButton) {
            minusButton.addEventListener('click', () => {
                setTimeout(() => {
                    const currentValue = parseInt(quantityInput.value, 10) || minQty;
                    const newValue = Math.max(minQty, currentValue - step);
                    quantityInput.value = newValue;
                    addToCartButton.setAttribute('data-bold-quantity', newValue);
                    lastValue = newValue;
                    updateButtonStates(newValue);
                    updatePrice(newValue);
                }, 10);
            });
        }

        // Input change handler for manual entry
        quantityInput.addEventListener('change', (e) => {
            const adjustedValue = validateAndAdjust(e.target.value);
            e.target.value = adjustedValue;
            addToCartButton.setAttribute('data-bold-quantity', adjustedValue);
            lastValue = adjustedValue;
            updateButtonStates(adjustedValue);
            updatePrice(adjustedValue);
        });

        // Input blur handler for manual entry
        quantityInput.addEventListener('blur', (e) => {
            const adjustedValue = validateAndAdjust(e.target.value);
            e.target.value = adjustedValue;
            addToCartButton.setAttribute('data-bold-quantity', adjustedValue);
            lastValue = adjustedValue;
            updateButtonStates(adjustedValue);
            updatePrice(adjustedValue);
        });

        // Initial button state update
        const initialValue = validateAndAdjust(quantityInput.value);
        if (initialValue !== parseInt(quantityInput.value, 10)) {
            quantityInput.value = initialValue;
            addToCartButton.setAttribute('data-bold-quantity', initialValue);
        }
        lastValue = initialValue;
        updateButtonStates(initialValue);
        
        // Initial price update
        updatePrice(initialValue);
    }

    /**
     * Set up add to cart button with processing state and cart refresh handling
     */
    _setupUpsellAddToCartButton(offerElement, addToCartButton) {
        // Track processing state
        let isProcessing = false;
        
        // Handle button click - add processing state
        addToCartButton.addEventListener('click', (e) => {
            // Don't prevent default - let BOLD handle the actual add to cart
            // Just add processing state
            if (isProcessing) {
                e.preventDefault();
                e.stopPropagation();
                return;
            }
            
            isProcessing = true;
            addToCartButton.classList.add('processing', 'loading');
            addToCartButton.disabled = true;
            
            // Store original button text if needed
            const buttonText = addToCartButton.querySelector('span');
            if (buttonText && !addToCartButton.dataset.originalText) {
                addToCartButton.dataset.originalText = buttonText.textContent;
            }
            
            // Update button text to show processing
            if (buttonText) {
                buttonText.textContent = 'Adding...';
            }
            
            // Set a timeout to remove processing state if cart update doesn't fire
            // (fallback in case BOLD doesn't trigger the event)
            const processingTimeout = setTimeout(() => {
                if (isProcessing) {
                    console.warn('Add to cart processing timeout - removing processing state');
                    this._removeUpsellProcessingState(offerElement, addToCartButton);
                    isProcessing = false;
                }
            }, 10000); // 10 second timeout
            
            // Store timeout ID for cleanup
            offerElement._addToCartTimeout = processingTimeout;
        });
        
        // Listen for cart update to remove processing state
        const handleCartUpdate = ({ req, sections }) => {
            if (isProcessing) {
                // Remove processing state
                this._removeUpsellProcessingState(offerElement, addToCartButton);
                isProcessing = false;
                
                // Clear timeout
                if (offerElement._addToCartTimeout) {
                    clearTimeout(offerElement._addToCartTimeout);
                    offerElement._addToCartTimeout = null;
                }
                
                // Trigger cart drawer refresh
                // The cart-live-region components will automatically update if sections are provided
                if (sections) {
                    // Cart drawer sections will be updated automatically by cart-live-region
                    // Re-process upsell offers in case they changed
                    setTimeout(() => {
                        this._processUpsellOffers();
                    }, 500);
                } else {
                    // If no sections provided, trigger manual refresh
                    setTimeout(() => {
                        this._triggerCartRefresh();
                    }, 500);
                }
            }
        };
        
        // Listen for cart error to remove processing state
        const handleCartError = () => {
            if (isProcessing) {
                this._removeUpsellProcessingState(offerElement, addToCartButton);
                isProcessing = false;
                
                if (offerElement._addToCartTimeout) {
                    clearTimeout(offerElement._addToCartTimeout);
                    offerElement._addToCartTimeout = null;
                }
            }
        };
        
        // Subscribe to cart events (use once: true so each button only listens once)
        // We'll use a unique identifier to track this specific offer's handlers
        const handlerId = `upsell-${Date.now()}-${Math.random()}`;
        offerElement._handlerId = handlerId;
        
        // Create bound handlers that check if this offer is still processing
        const boundCartUpdate = (eventData) => {
            if (offerElement.dataset.processed && isProcessing) {
                handleCartUpdate(eventData);
            }
        };
        
        const boundCartError = () => {
            if (offerElement.dataset.processed && isProcessing) {
                handleCartError();
            }
        };
        
        this.sub(Events.CART_UPDATE, boundCartUpdate, { global: true });
        this.sub(Events.CART_ERROR, boundCartError, { global: true });
        
        // Store handlers for cleanup
        offerElement._cartUpdateHandler = boundCartUpdate;
        offerElement._cartErrorHandler = boundCartError;
    }
    
    /**
     * Remove processing state from add to cart button
     */
    _removeUpsellProcessingState(offerElement, addToCartButton) {
        addToCartButton.classList.remove('processing', 'loading');
        addToCartButton.disabled = false;
        
        // Restore original button text
        const buttonText = addToCartButton.querySelector('span');
        if (buttonText && addToCartButton.dataset.originalText) {
            buttonText.textContent = addToCartButton.dataset.originalText;
            delete addToCartButton.dataset.originalText;
        }
    }

    /**
     * Trigger cart refresh to update cart drawer contents
     */
    _triggerCartRefresh() {
        // Method 1: Dispatch cart:refresh event (cart-provider listens to this)
        const refreshEvent = new CustomEvent('cart:refresh');
        document.dispatchEvent(refreshEvent);
        
        // Method 2: Also trigger a manual refresh after a short delay
        // to ensure cart drawer updates even if the event doesn't work
        setTimeout(() => {
            // Check if cart-provider exists and call its refresh method
            const cartProvider = document.querySelector('cart-provider');
            if (cartProvider && typeof cartProvider._cartRefresh === 'function') {
                cartProvider._cartRefresh();
            } else {
                // Fallback: Manually fetch cart sections and update
                this._manualCartRefresh();
            }
        }, 300);
    }
    
    /**
     * Manually refresh cart drawer by fetching updated sections
     */
    async _manualCartRefresh() {
        try {
            // Get the cart drawer section ID
            const cartDrawer = this;
            const sectionId = cartDrawer.sectionId;
            
            if (!sectionId) {
                console.warn('Cart drawer section ID not found');
                return;
            }
            
            // Fetch updated cart sections
            const sectionsUrl = `${window.dynamicURLs?.root || window.location.origin}?sections=${sectionId}`;
            const response = await fetch(sectionsUrl);
            
            if (!response.ok) {
                console.warn('Failed to fetch cart sections for refresh');
                return;
            }
            
            const sections = await response.json();
            const sectionContent = sections[sectionId];
            
            if (sectionContent) {
                // Publish CART_UPDATE event with sections to trigger cart-live-region updates
                this.pub(Events.CART_UPDATE, {
                    sections: sections,
                    req: 'cartRefresh'
                });
                
                // Re-process upsell offers after refresh
                setTimeout(() => {
                    this._processUpsellOffers();
                }, 500);
            }
        } catch (error) {
            console.error('Error manually refreshing cart:', error);
        }
    }

    _handleAddingToCart({ req, sections }) {
        if(req === 'cartAdd') {
            this.$('modal').open();
            
            // If sections are provided, cart-live-region components will automatically update
            // Re-process upsell offers after a delay to ensure they're updated
            if (sections) {
                setTimeout(() => {
                    // Re-process upsell offers in case they changed
                    this._processUpsellOffers();
                }, 500);
            } else {
                // If no sections provided, trigger manual refresh
                setTimeout(() => {
                    this._triggerCartRefresh();
                }, 500);
            }
        }
    }
 
    _handleCartChange({ key }) {
    this.updatingProduct = this.querySelector(`[data-item-key="${key}"]`);
    if (!this.updatingProduct) {
        return;
    }

    if (typeof window.debouncedPriceUpdate === 'function') {
        window.debouncedPriceUpdate();
    } else if (typeof window.updateCartPrices === 'function') {
        setTimeout(() => {
            window.updateCartPrices();
        }, 100);
    }
}

    _handleMute() {
        this.unsub(Events.CART_UPDATE);
    }

    _handleCartError() {
        this.updatingProduct && $loading(this.updatingProduct, false);
        document.querySelectorAll('cart-qty.loading').forEach((el) => {
            el.classList.remove('loading');
            el.removeAttribute('disabled');
        });
    }
})